import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as api from "../../api/getapi";
import useApi from "../../Hooks/useApi";
import * as postapi from "../../api/postapi";
import Loader from "../Loader";
import { TIMEOUT } from "../../Features/dateTime";
import { toast } from "react-toastify";
import SearchInput from "../SearchInput";
import ReactSelect from "../ReactSelect";
const FulfilledByTMModal = ({ show, onHide, toggle }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [costPrice, setCostPrice] = useState("");
  const [paymentType, setPaymentType] = useState("cash");
  const fetchAllOrders = useApi(api.fetchAllOrders, { hasCatchError: true });
  const updateOrder = useApi(postapi.moveD4uOrderToTM, { hasCatchError: true });

  const getDeliverForYouOrder = async (search) => {
    return new Promise((resolve, reject) => {
      fetchAllOrders
        .request({
          search: search,
          status: paymentType === "cash" ? { value: "Pending", label: "Pending" } : { value: "Verifying Payment", label: "Verifying Payment" },
          orderBy: { created_at: "DESC" },
        })
        .then((res) => {
          const getData = res?.data?.data?.map((cat) => ({
            value: cat,
            label: (
              <>
                <strong className="fs-12" name={cat.shop_name}>
                  [{cat.id}]-{cat.order_number}
                </strong>
                <p className="fs-10 text-lowercase">
                  Title:&nbsp;&nbsp;<strong className="fs-10">{cat.listing_title}</strong>
                  <br />
                  Order Price:&nbsp;&nbsp;<strong className="fs-10">{cat.total_price}</strong>
                </p>
              </>
            ),
            name: cat.order_number,
          }));
          resolve(getData);
        })
        .catch((err) => {
          reject("err" + err);
        });
    });
  };
  const handleOrderNumberChange = (e) => {
    if (!e) {
      setOrder(null); // Set Order to null when cleared
      return;
    }

    setOrder({
      value: e.value,
      label: e.name,
    });
  };

  const hideModal = () => {
    onHide();
    setOrder(null);
    setCostPrice("");
    toggle();
  };

  const handleSubmit = async (e) => {
    try {
      setIsClicked(true);
      const payload = {
        order_id: order?.value?.id,
        cost_price_per_item: costPrice,
      };
      const data = await updateOrder.request(payload);
      if (data) {
        setIsClicked(false);
        toast.success("Order moved to Techbazaar Mall successfully", { position: "bottom-right", autoClose: 1500, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined });
        hideModal();
      }
    } catch (error) {
      console.log(error);
      setIsClicked(false);
    }
  };

  return (
    <>
      <Modal aria-labelledby="contained-modal-title-vcenter" centered size="lg" backdrop="static" show={show} onHide={hideModal}>
        <Modal.Header className="border-0 pt-3 border-bottom" closeButton={hideModal}>
          <div className="d-flex align-items-center gap-4">
            <h4>{"Fulfilled by Techbazaar Mall"}</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <div
              style={{
                height: "50vh",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Loader />
            </div>
          ) : order?.length === 0 ? (
            <div className="text-center">No Such Order Found</div>
          ) : (
            <>
              <Row className="p-3">
                <Col md={12} className="py-2">
                  <Form.Group className="w-100" controlId="formBasicOrderNumber">
                    <Form.Label>
                      Payment Type<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Check type="radio" name="paymentType" label="Cash" checked={paymentType === "cash"} onChange={(e) => setPaymentType("cash")} />
                    <Form.Check type="radio" name="paymentType" label="Card" checked={paymentType === "card"} onChange={(e) => setPaymentType("card")} />
                    <Form.Control className="p-2" name="shop" hidden type="text" value={order ? order?.value : null} onChange={() => {}} required />
                    <Form.Control.Feedback type="invalid">* Please Select Shop</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={12} className="py-2">
                  <Form.Group className="w-100" controlId="formBasicOrderNumber">
                    <label>
                      Order #<span className="text-danger">*</span>
                    </label>
                    <ReactSelect
                      cacheOptions={false}
                      placeholder="Search Order Number"
                      value={order}
                      searchable={true}
                      options={getDeliverForYouOrder}
                      isClearable={true}
                      handleChange={handleOrderNumberChange}
                      onInputChange={(newInput) => {
                        return newInput;
                      }}
                    />
                    <Form.Control className="p-2" name="shop" hidden type="text" value={order ? order?.value : null} onChange={() => {}} required />
                    <Form.Control.Feedback type="invalid">* Please Select Shop</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={12} className="py-2">
                  <Form.Group className="mt-1" as={Col} controlId="price">
                    <label>
                      Cost Price per Unit<span className="text-danger">*</span>
                    </label>
                    <Form.Control
                      value={costPrice}
                      type="number"
                      placeholder="Rs.1000"
                      onKeyDown={(e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()}
                      onChange={(e) => {
                        if (Number(e.target.value) > 0) {
                          setCostPrice(e.target.value);
                        } else {
                          setCostPrice("");
                        }
                      }}
                    />
                    <Form.Control.Feedback type="invalid">Please Enter Amount</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" style={{ fontSize: "14px" }} onClick={handleSubmit} disabled={isClicked || !(order && Number(costPrice) > 0)}>
            <span>Update</span>
          </Button>
          <Button size="sm" variant="outline-secondary" style={{ fontSize: "14px" }} onClick={hideModal}>
            <span>Close</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FulfilledByTMModal;
